// actions.js

export const SET_SELECTED_BRANCH_ID = 'SET_SELECTED_BRANCH_ID'

export const setSelectedBranchId = (branchId) => ({
  type: SET_SELECTED_BRANCH_ID,
  payload: branchId
})
